<div class="modal-header">
  <h4 class="modal-title">Please confirm</h4>
</div>
<div class="modal-body">
  <p [innerHtml]="message"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close()">
    Submit
  </button>
  <button type="button" class="btn btn-warning" (click)="activeModal.dismiss()">
    Cancel
  </button>
</div>
